import { Heading5 } from 'app/ui-components/typography/Heading.styles';
import { errorStatistics } from 'app/utils/statistics/universalStatistics';
import { useRouter } from 'next/router';
import * as React from 'react';
import SendStatistics from '../CommonElements/SendStatistics';
import BackButton from '../VideoPlayer/new/BackButton';
import { ErrorContainer, RightsLink, Description } from './VideoModalStyles';
import PlayText, { TYPES } from 'app/ui-components/typography/PlayText/PlayText';

const MissingContent = () => {
    return (
        <>
            <Heading5>Programmet kunde inte hittas</Heading5>
            <Description>
                Det här programmet är inte tillgängligt, vilket kan bero på att det är avpublicerat
            </Description>
            <Description>
                <RightsLink href="https://kontakt.svt.se/guide/rattigheter">
                    <PlayText type={TYPES.DEFAULT}>Hur funkar upphovsrätt i SVT Play?</PlayText>
                </RightsLink>
            </Description>
        </>
    );
};

const UnknownError = () => {
    return (
        <>
            <Heading5>Programmet kunde inte laddas</Heading5>
            <Description>
                Vi ber om ursäkt, men just nu går det inte att spela programmet. Klicka på Tillbaka och försök
                igen.
            </Description>
        </>
    );
};

export const Error = ({ error }) => {
    const router = useRouter();

    const isError = error;
    const code = isError ? 500 : 404;

    return (
        <>
            <BackButton>Tillbaka</BackButton>

            <ErrorContainer>
                {isError ? <UnknownError /> : <MissingContent />}
                <SendStatistics statisticsObject={errorStatistics(code, router.asPath)} />
            </ErrorContainer>
        </>
    );
};

export default Error;
